import getTranslationIfExists from "./getTranslationIfExists";

export default function getTranslatedErrorMessageByHttpErrorCode(errorCode, defaultValue) {
  return getTranslationIfExists(`errorCodes.${errorCode}`, defaultValue);
}
